export const MAX_RETRIES = 1
